import Api from '../../index';
import { endPoints, requestType } from '../../../constants/variables';

export const fetchReportById = (params) => {
  return Api(endPoints.generateReport, params, requestType.POST);
};
